import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

$w.onReady(function () {
    let query = wixLocation.query;
    if (query.success) {
        wixWindow.openLightbox(query.success);
    }
});
